import { TPropertyCardPropertyData } from '@/card/card-types';
import { CITY_MODES, FIRST_PAGE, NAV_ITEMS } from '@/constants';
import * as dashboardActions from '@/dashboard/dashboard-actions';
import { MapboxInstanceMgr } from '@/map/map-instance';
import { pulsingDotMgr } from '@/map/pulsing-dot/pulsing-dot-mgr';
import * as userSelectors from '@/user/user-selectors';
import { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { PropertyCardBody } from './modules/property-card-body';
import { PropertyCardHeader } from './modules/property-card-header';
import { PropertyCardWrapper } from './modules/property-card-wrapper';

// Seems to be abandoned
// TODO: Update to read from props when final status of print mode button is determined (currently hidden)
const isPrintMode = false;

const origin = 'property-card';

interface Props {
  /** 1-indexed page number for pagination */
  currentPage: number;
  propertyData: TPropertyCardPropertyData;
}

export function PropertyCard(props: Props) {
  const { currentPage, propertyData } = props;

  const dispatch = useDispatch();

  const cityMode = useSelector(userSelectors.derivedCityMode);
  const isContentHidden =
    cityMode === CITY_MODES.trial && currentPage > FIRST_PAGE;

  const onPropertyCardClick = useCallback(() => {
    dispatch(
      dashboardActions.openPropertyByDeckardId([
        NAV_ITEMS.home,
        propertyData.deckardid,
      ])
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [propertyData.deckardid]);

  const handleMouseEnter = () => {
    if (MapboxInstanceMgr.verifyStylesHaveLoaded()) {
      pulsingDotMgr.highlightPropertyOnMap(propertyData, origin);
    }
  };

  const handleMouseLeave = () => {
    pulsingDotMgr.unhighlightPropertyOnMap(propertyData.deckardid);
  };

  return (
    <PropertyCardWrapper
      isContentHidden={isContentHidden}
      handleCardOnClick={onPropertyCardClick}
      handleMouseEnter={handleMouseEnter}
      handleMouseLeave={handleMouseLeave}
    >
      <PropertyCardHeader
        isContentHidden={isContentHidden}
        printMode={isPrintMode}
        coverImageUrl={propertyData.coverImageUrl}
        onlinePlatforms={propertyData.onlinePlatforms}
      />

      <PropertyCardBody {...propertyData} printMode={isPrintMode} />
    </PropertyCardWrapper>
  );
}
